module.exports = new __parcel__URL__("Office.c83f6dbc.jpg").toString();